import { createI18n } from 'vue-i18n';
import locales from '@/i18n/index.js';

const { zhTw } = locales;

const i18n = createI18n({
  legacy: false,
  locale: 'zh-TW',
  fallbackLocale: 'zh-TW',
  messages: {
    'zh-TW': zhTw
  }
});

export default i18n;
